import { render, staticRenderFns } from "./WotConfirm.vue?vue&type=template&id=01eed81e"
import script from "./WotConfirm.vue?vue&type=script&lang=js"
export * from "./WotConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports